/* eslint-disable react/forbid-dom-props */
import React from 'react'

export const EditPhotoIcon = () => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="40" height="40">
    <defs>
      <path
        id="edit_photo_a"
        d="M12 2.775v6.75c0 .621-.504 1.125-1.125 1.125h-9.75A1.125 1.125 0 010 9.525v-6.75C0 2.154.504 1.65 1.125 1.65h2.062l.289-.771A1.122 1.122 0 014.528.15H7.47c.468 0 .888.29 1.052.729l.29.771h2.063c.621 0 1.125.504 1.125 1.125zM8.812 6.15A2.814 2.814 0 006 3.337 2.815 2.815 0 003.187 6.15 2.815 2.815 0 006 8.963 2.815 2.815 0 008.813 6.15zm-.75 0A2.065 2.065 0 016 8.213c-1.137 0-2.063-.926-2.063-2.063S4.863 4.087 6 4.087s2.063.926 2.063 2.063z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle
        cx="20"
        cy="20"
        r="18"
        fill="#9A8B88"
        stroke="#FFF"
        strokeWidth="4"
      />
      <g transform="translate(14 15)">
        <mask id="edit_photo_b" fill="#fff">
          <use xlinkHref="#edit_photo_a" />
        </mask>
        <g fill="#FFF" fillRule="nonzero" mask="url(#edit_photo_b)">
          <path d="M-1.2-1.8h14.4v14.4H-1.2z" />
        </g>
      </g>
    </g>
  </svg>
)
